module.exports = __webpack_public_path__ + "static/img/Cardfooter02.70af7f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cardfooter02.png
// module id = /9Vo
// module chunks = 1